export default __webpack_public_path__ + "static/media/maxime_cross.aec37533.jpg";